import { ImageBlockSchema } from '@blocksuite/affine-model';
import {
  BlockNotionHtmlAdapterExtension,
  type BlockNotionHtmlAdapterMatcher,
  HastUtils,
} from '@blocksuite/affine-shared/adapters';

import { processImageNodeToBlock } from './utils';

export const imageBlockNotionHtmlAdapterMatcher: BlockNotionHtmlAdapterMatcher =
  {
    flavour: ImageBlockSchema.model.flavour,
    toMatch: o => {
      return (
        HastUtils.isElement(o.node) &&
        (o.node.tagName === 'img' ||
          (o.node.tagName === 'figure' &&
            !!HastUtils.querySelector(o.node, '.image')))
      );
    },
    fromMatch: () => false,
    toBlockSnapshot: {
      enter: async (o, context) => {
        if (!HastUtils.isElement(o.node)) {
          return;
        }
        const { assets, walkerContext, configs } = context;
        if (!assets) {
          return;
        }
        if (walkerContext.getGlobalContext('hast:disableimg')) {
          return;
        }

        switch (o.node.tagName) {
          case 'img': {
            const image = o.node;
            const imageURL =
              typeof image?.properties.src === 'string'
                ? image.properties.src
                : '';
            if (imageURL) {
              // 🔥 提取 img 元素的元数据
              const alt = typeof image.properties.alt === 'string' ? image.properties.alt : null;
              const title = typeof image.properties.title === 'string' ? image.properties.title : null;
              
              await processImageNodeToBlock(
                imageURL,
                walkerContext,
                assets,
                configs,
                undefined,
                { alt, title, originalUrl: imageURL }
              );
            }
            break;
          }
          case 'figure': {
            const imageFigureWrapper = HastUtils.querySelector(
              o.node,
              '.image'
            );
            let imageURL = '';
            let alt: string | null = null;
            let title: string | null = null;
            
            if (imageFigureWrapper) {
              const image = HastUtils.querySelector(imageFigureWrapper, 'img');
              imageURL =
                typeof image?.properties.src === 'string'
                  ? image.properties.src
                  : '';
              // 🔥 提取 img 元素的元数据
              alt = typeof image?.properties.alt === 'string' ? image.properties.alt : null;
              title = typeof image?.properties.title === 'string' ? image.properties.title : null;
            }
            if (imageURL) {
              await processImageNodeToBlock(
                imageURL,
                walkerContext,
                assets,
                configs,
                undefined,
                { alt, title, originalUrl: imageURL }
              );
            }
            break;
          }
        }
      },
    },
    fromBlockSnapshot: {},
  };

export const ImageBlockNotionHtmlAdapterExtension =
  BlockNotionHtmlAdapterExtension(imageBlockNotionHtmlAdapterMatcher);
